import { makeAutoObservable } from 'mobx';
import SearchType from '../interfaces/SearchType';

export default class SearchStore {
    query: string = "";
    type: SearchType = SearchType.Address;
    isOpen: boolean = false;
    selectedItemIndex: number | null = null;
    openSelectedItemCallbacks: { [key: number]: (() => void) | undefined } = {};

    constructor() {
        makeAutoObservable(this);
    }

    setQuery(query: string) {
        this.query = query;
    }

    setType(type: SearchType) {
        this.type = type;
    }

    setIsOpen(isOpen: boolean) {
        this.isOpen = isOpen;
    }

    setSelectedItemIndex(value: number | null) {
        this.selectedItemIndex = value;
    }

    moveSelectedItemIndexDown(itemCount: number) {
        if (this.selectedItemIndex === null) {
            this.setSelectedItemIndex(0);
        } else if (this.selectedItemIndex === itemCount - 1) {
            this.setSelectedItemIndex(null);
        } else {
            this.setSelectedItemIndex(this.selectedItemIndex + 1);
        }
    }

    moveSelectedItemIndexUp(itemCount: number) {
        if (this.selectedItemIndex === null) {
            this.setSelectedItemIndex(itemCount - 1);
        } else if (this.selectedItemIndex === 0) {
            this.setSelectedItemIndex(null);
        } else {
            this.setSelectedItemIndex(this.selectedItemIndex - 1);
        }
    }

    setSearch(query: string, type: SearchType) {
        this.setQuery(query);
        this.setType(type);
        this.setIsOpen(true);
    }

    addOpenSelectedItemCallback(key: number, callback: () => void) {
        this.openSelectedItemCallbacks = {
            ...this.openSelectedItemCallbacks,
            [key]: callback,
        };
    }

    removeOpenSelectedItemCallback(key: number) {
        this.openSelectedItemCallbacks = {
            ...this.openSelectedItemCallbacks,
            [key]: undefined,
        };
    }

    openSelectedItem() {
        if (this.isOpen && this.selectedItemIndex !== null && this.openSelectedItemCallbacks[this.selectedItemIndex]) {
            this.openSelectedItemCallbacks[this.selectedItemIndex]!();
        } else if (this.isOpen && this.selectedItemIndex === null && this.openSelectedItemCallbacks[0]) {
            this.openSelectedItemCallbacks[0]();
        }
    }

    clear() {
        this.setQuery("");
        this.setType(SearchType.Address);
        this.setIsOpen(false);
        this.setSelectedItemIndex(null);
        this.openSelectedItemCallbacks = {};
    }
}